export default "__VITE_ASSET__DhyuRaRd__"